/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The TankResponse model module.
* @module model/TankResponse
* @version 2020-12-7
*/
export default class TankResponse {
    /**
    * Constructs a new <code>TankResponse</code>.
    * タンク
    * @alias module:model/TankResponse
    * @class
    * @param id {Number} タンクID
    * @param tankType {Number} タンクタイプID
    * @param oilMaxVolume {Number} 最大容量
    * @param tankMaxVolume {Number} 法定容量
    * @param oilLevel {Number} 液面までの距離
    * @param oilVolume {Number} 灯油残量
    * @param volumeThreshold {Number} 灯油残量しきい値
    * @param sensorInstalledAt {Number} センサー設置時刻
    * @param volumeMargin {Number} 灯油残量余裕値
    * @param deliveryFrequency {Number} 配送頻度
    */

    constructor(id, tankType, oilMaxVolume, tankMaxVolume, oilLevel, oilVolume, volumeThreshold, sensorInstalledAt, volumeMargin, deliveryFrequency) {
        
        
        this['id'] = id;
        this['tankType'] = tankType;
        this['oilMaxVolume'] = oilMaxVolume;
        this['tankMaxVolume'] = tankMaxVolume;
        this['oilLevel'] = oilLevel;
        this['oilVolume'] = oilVolume;
        this['volumeThreshold'] = volumeThreshold;
        this['sensorInstalledAt'] = sensorInstalledAt;
        this['volumeMargin'] = volumeMargin;
        this['deliveryFrequency'] = deliveryFrequency;
        
    }

    /**
    * Constructs a <code>TankResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TankResponse} obj Optional instance to populate.
    * @return {module:model/TankResponse} The populated <code>TankResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TankResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('tankType')) {
                obj['tankType'] = ApiClient.convertToType(data['tankType'], 'Number');
            }
            if (data.hasOwnProperty('oilMaxVolume')) {
                obj['oilMaxVolume'] = ApiClient.convertToType(data['oilMaxVolume'], 'Number');
            }
            if (data.hasOwnProperty('tankMaxVolume')) {
                obj['tankMaxVolume'] = ApiClient.convertToType(data['tankMaxVolume'], 'Number');
            }
            if (data.hasOwnProperty('oilLevel')) {
                obj['oilLevel'] = ApiClient.convertToType(data['oilLevel'], 'Number');
            }
            if (data.hasOwnProperty('oilVolume')) {
                obj['oilVolume'] = ApiClient.convertToType(data['oilVolume'], 'Number');
            }
            if (data.hasOwnProperty('volumeThreshold')) {
                obj['volumeThreshold'] = ApiClient.convertToType(data['volumeThreshold'], 'Number');
            }
            if (data.hasOwnProperty('volumeUpdatedAt')) {
                obj['volumeUpdatedAt'] = ApiClient.convertToType(data['volumeUpdatedAt'], 'Number');
            }
            if (data.hasOwnProperty('sensorInstalledAt')) {
                obj['sensorInstalledAt'] = ApiClient.convertToType(data['sensorInstalledAt'], 'Number');
            }
            if (data.hasOwnProperty('volumeMargin')) {
                obj['volumeMargin'] = ApiClient.convertToType(data['volumeMargin'], 'Number');
            }
            if (data.hasOwnProperty('consumptionRate')) {
                obj['consumptionRate'] = ApiClient.convertToType(data['consumptionRate'], 'Number');
            }
            if (data.hasOwnProperty('customerId')) {
                obj['customerId'] = ApiClient.convertToType(data['customerId'], 'Number');
            }
            if (data.hasOwnProperty('deliveryFrequency')) {
                obj['deliveryFrequency'] = ApiClient.convertToType(data['deliveryFrequency'], 'Number');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('serialNo')) {
                obj['serialNo'] = ApiClient.convertToType(data['serialNo'], 'String');
            }
        }
        return obj;
    }

    /**
    * タンクID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * タンクタイプID
    * @member {Number} tankType
    */
    'tankType' = undefined;
    /**
    * 最大容量
    * @member {Number} oilMaxVolume
    */
    'oilMaxVolume' = undefined;
    /**
    * 法定容量
    * @member {Number} tankMaxVolume
    */
    'tankMaxVolume' = undefined;
    /**
    * 液面までの距離
    * @member {Number} oilLevel
    */
    'oilLevel' = undefined;
    /**
    * 灯油残量
    * @member {Number} oilVolume
    */
    'oilVolume' = undefined;
    /**
    * 灯油残量しきい値
    * @member {Number} volumeThreshold
    */
    'volumeThreshold' = undefined;
    /**
    * 灯油残量更新時刻
    * @member {Number} volumeUpdatedAt
    */
    'volumeUpdatedAt' = undefined;
    /**
    * センサー設置時刻
    * @member {Number} sensorInstalledAt
    */
    'sensorInstalledAt' = undefined;
    /**
    * 灯油残量余裕値
    * @member {Number} volumeMargin
    */
    'volumeMargin' = undefined;
    /**
    * 灯油消費レート
    * @member {Number} consumptionRate
    */
    'consumptionRate' = undefined;
    /**
    * 顧客Id
    * @member {Number} customerId
    */
    'customerId' = undefined;
    /**
    * 配送頻度
    * @member {Number} deliveryFrequency
    */
    'deliveryFrequency' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * シリアルNo
    * @member {String} serialNo
    */
    'serialNo' = undefined;




}
